import axios from 'axios';
import router from '@/router';
import auth from '@/utils/auth';

import {
  LOGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,

  LOGOUT,

  VERIFY,
  VERIFY_ERROR,
  VERIFY_SUCCESS,

  SAVE_SETTINGS,
  SAVE_SETTINGS_ERROR,
  SAVE_SETTINGS_SUCCESS,

  // SAVE_PFCONTRIBUTION,
  // SAVE_PFCONTRIBUTION_SUCCESS,
  // SAVE_PFCONTRIBUTION_ERROR,

  FORGOT_PASSWORD,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_SUCCESS,

  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_SUCCESS,

} from './constants';

export default {
  async [LOGIN]({ commit }, payload) {
    try {
      commit(LOGIN);
      const response = await axios({
        url: `${process.env.API_URL}/api/login`,
        method: 'POST',
        data: payload,
      });
      commit(LOGIN_SUCCESS, response.data);
      router.push({ name: 'Syndicate Listing' });
    } catch (err) {
      commit(LOGIN_ERROR, err);
    }
  },

  [LOGOUT]({ commit }) {
    router.push({ name: 'Login' });
    commit(LOGOUT);
  },

  async [VERIFY]({ commit }) {
    try {
      commit(VERIFY);
      const response = await axios({
        url: `${process.env.API_URL}/api/verify`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(VERIFY_SUCCESS, response.data);
    } catch (err) {
      commit(VERIFY_ERROR, err);
      router.push('/login');
    }
  },

  async [SAVE_SETTINGS]({ commit }, data) {
    try {
      commit(SAVE_SETTINGS);
      const response = await axios({
        url: `${process.env.API_URL}/api/users/${data.userID}/settings`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_SETTINGS_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_SETTINGS_ERROR, err.response.data);
    }
  },

  // async [SAVE_PFCONTRIBUTION]({ commit }, data) {
  //   try {
  //     commit(SAVE_PFCONTRIBUTION);
  //     const url = `${process.env.API_URL}/api/suggested-provident-fund`;
  //     const method = 'POST';
  //     const response = await axios({
  //       url,
  //       method,
  //       headers: auth.getAuthHeader(),
  //       data,
  //     });
  //     commit(SAVE_PFCONTRIBUTION_SUCCESS, response.data);
  //   } catch (err) {
  //     commit(SAVE_PFCONTRIBUTION_ERROR, err.response.data);
  //   }
  // },

  async [FORGOT_PASSWORD]({ commit }, data) {
    try {
      commit(FORGOT_PASSWORD);
      const response = await axios({
        url: `${process.env.API_URL}/api/forgot-password`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(FORGOT_PASSWORD_SUCCESS, response.data);
    } catch (err) {
      commit(FORGOT_PASSWORD_ERROR, err);
    }
  },

  async [CHANGE_PASSWORD]({ commit }, data) {
    try {
      commit(CHANGE_PASSWORD);
      const response = await axios({
        url: `${process.env.API_URL}/api/users/${data.userID}/password`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(CHANGE_PASSWORD_SUCCESS, response.data);
    } catch (err) {
      commit(CHANGE_PASSWORD_ERROR, err.response.data);
    }
  },

};



// WEBPACK FOOTER //
// ./src/store/actions.js